import { Box, Text, HStack, Flex } from '@chakra-ui/react';
import { Button } from 'components/Button';

type ExperienceImageTileProps = {
    data: {
        image: string;
        title: string;
        subtitle: string;
        url: string;
    }
};

const ExperienceImageTile = ({data}: ExperienceImageTileProps) => {

  const getTheAppBtnOnClick = () => {
    console.log(data.url)
  }

  return (
    <>
      <Box
        height={300}
        width={500}
        backgroundImage={data.image}
        backgroundRepeat='no-repeat'
        backgroundPosition='top'
        backgroundSize='cover'
        marginRight={10}
        borderRadius='50'
      >
        <HStack justifyContent='flex-start' height='100%'>
          <Flex
            flexDirection='column'
            justifyContent='flex-start'
            alignItems='flex-start'
            height='100%'
            width='50%'
            backdropBlur='blur(50px)'
            gap={3}
            borderRadius='0px 50px 50px 0px'
          >
            <Text paddingLeft={7} paddingTop={5} fontWeight={500} fontSize='16px' color='#FFFFFF' lineHeight='11'>
                {data.title}
            </Text>
            <Text paddingLeft={7} marginTop='-20px' fontWeight={600} fontSize='20px' color='#FFFFFF' lineHeight='6'>
                {data.subtitle}
            </Text>
            <Button
                label='Learn more'
                onClick={getTheAppBtnOnClick}
                variant='solid'
                colorScheme='whiteAlpha'
                size='lg'
                minWidth={200}
            />
          </Flex>
        </HStack>
      </Box>
    </>
  );
};

export { ExperienceImageTile };
